import { useQuery } from '@tanstack/react-query';
import { AxiosHeaders } from 'axios';
import { API } from 'network/api';
import { PackageListDTO, PackageTrackerCommonFilterQueryParams } from '../types';

export interface PackageListQueryParams extends PackageTrackerCommonFilterQueryParams {
  page: number;
  size: number;
  'agId.in'?: string;
  'salesStatus.in'?: string;
  'packageStatus.in'?: string;
  'soNumber.contains'?: string;
  'farmerGroupId.in'?: string;
  'lastModifiedDate.lessThan'?: string;
  'invoicePrimaryId.specified'?: boolean;
}

interface UsePackageQueryProps {
  params?: PackageListQueryParams;
  token?: string;
}

const usePackagesQuery = ({ params, token }: UsePackageQueryProps) => {
  const {
    data: res,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['packages', { params, token }], // when a different user logs in, the query key will change hence the query will be refetched
    queryFn: async ({ signal }) => {
      const res = await API.get('/packages', {
        params,
        signal,
      });
      return {
        data: res?.data as PackageListDTO,
        totalCount:
          Number((res?.headers as AxiosHeaders)?.get('X-Total-Count')) || 0,
      };
    },
    staleTime: 1000 * 20,
  });

  const data = res?.data;
  const totalCount = res?.totalCount;

  return {
    data,
    isLoading,
    error,
    totalCount,
  };
};

export default usePackagesQuery;
